import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
`;

export default Wrapper;
